.no-navigate {
  display: contents;
}

.tags {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
}
